import { render } from "./SharePercent.vue?vue&type=template&id=1c1da0f1"
import script from "./SharePercent.vue?vue&type=script&lang=js"
export * from "./SharePercent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/nex/company-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__